import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './company-token.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const CompanyTokenDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const companyTokenEntity = useAppSelector(state => state.companyToken.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="companyTokenDetailsHeading">
          <Translate contentKey="fleetSenseApp.companyToken.detail.title">CompanyToken</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{companyTokenEntity.id}</dd>
          <dt>
            <span id="token">
              <Translate contentKey="fleetSenseApp.companyToken.token">Token</Translate>
            </span>
          </dt>
          <dd>{companyTokenEntity.token}</dd>
          <dt>
            <span id="activated">
              <Translate contentKey="fleetSenseApp.companyToken.activated">Activated</Translate>
            </span>
          </dt>
          <dd>{companyTokenEntity.activated ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.companyToken.company">Company</Translate>
          </dt>
          <dd>{companyTokenEntity.company ? companyTokenEntity.company.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/company-token" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/company-token/${companyTokenEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default CompanyTokenDetail;
